"use client";
import { api } from "@/trpc/react";
// https://posthog.com/docs/libraries/next-js
import { usePathname, useSearchParams } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import { Suspense, useEffect } from "react";

export default function PostHogPageView() {
  return (
    <Suspense fallback={null}>
      <PostHogPageViewContent />
    </Suspense>
  );
}

function PostHogPageViewContent(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  // Track pageviews
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture("$pageview", {
        $current_url: url,
      });
    }
  }, [pathname, searchParams, posthog]);

  const user = api.user.findSelf.useQuery(undefined, {
    refetchOnMount: false,
  });

  useEffect(() => {
    if (user.data) {
      posthog.identify(user.data.id, {
        role: user.data.role,
      });
    }
  }, [user.data, posthog]);

  return null;
}
